import { address, user } from '@app/models';
import {gql} from 'apollo-angular';

export const updateUserMutation = gql`
  mutation UpdateUserMutation ($user: UserInput!) {
    user (user: $user) {
      ...user
    }
  }
  ${user}
`;

export const changePasswordMutation = gql`
  mutation ChangePasswordMutation ($changePassword: ChangePasswordInput!) {
    user (changePassword: $changePassword) {
      ...user
    }
  }
  ${user}
`;

export const updateAddressMutation = gql`
  mutation UpdateAddressMutation ($address: AddressInput!) {
    saveAddress (address: $address) {
      ...address
    }
  }
  ${address}
`;

export const updateFullScreenModeMutation = gql`
 mutation updateFullScreenMode {
   updateFullScreenMode {
     ...user
   }
 }
 ${user}
`;

export const updateDossierSideMenuConfigurationMutation = gql`
  mutation UpdateDossierSideMenuConfiguration {
    updateDossierSideMenuConfiguration {
      ...user
    }
  }
  ${user}
`;
